import React, { Fragment, useEffect } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import CompanyDashboardTop from './Top'
import CompanyDashboardProTracks from './ProTracks'
import CompanyDashboardCommits from './Commits'
import CompanyDashboardTopLoader from 'app/domains/common/Loaders/CompanyDashboardTopLoader'
import CompanyDashboardCommitsLoader from 'app/domains/common/Loaders/CompanyDashboardCommitsLoader'
import ChartLoader from 'app/domains/common/Loaders/ChartLoader'
import NoCompanyStats from 'app/components/NoActivitiesComponent'

import './styles.scss'

const baseClass = 'company-dashboard'
const id = baseClass
const CompanyDashboard = ({ t, data, pending, isEmpty, onDataLoad, setComponentsHeight }) => {
  useEffect(
    () => {
      setComponentsHeight(id)
    },
    [pending]
  )
  if (data && !isEmpty && onDataLoad) {
    onDataLoad()
  }
  return (
    <div className={baseClass} id={id}>
      {pending ? (
        <Fragment>
          <CompanyDashboardTopLoader />
          <ChartLoader />
          <CompanyDashboardCommitsLoader />
        </Fragment>
      ) : isEmpty ? (
        <NoCompanyStats topText={t('come-back-later')} customClass="completed-protracks" />
      ) : (
        <Fragment>
          <CompanyDashboardTop topActivity={data.get('topActivity')} favoriteActivity={data.get('favoriteActivity')} />
          <div className="companyDashboard__wrapper">
            <CompanyDashboardProTracks proTracks={data.get('proTracksStats')} />
            <CompanyDashboardCommits commits={data.get('engagements')} />
          </div>
        </Fragment>
      )}
    </div>
  )
}
CompanyDashboard.propTypes = {
  pending: PropTypes.bool.isRequired,
  isEmpty: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    topActivity: PropTypes.any,
    favoriteActivity: PropTypes.any,
    proTracksStats: PropTypes.any,
    engagements: PropTypes.any,
  }),
}

export default withTranslation('user')(CompanyDashboard)
